import React, { useState } from 'react';
import { StarIcon, SendIcon } from 'lucide-react';
import Header from '../components/Header';
const Feedback = () => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    // In een echte app zou dit naar een API gaan
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-343">
        <Header title="Feedback & Reviews" showBackButton data-id="element-344" />
        <div className="p-4 flex-1 flex flex-col items-center justify-center" data-id="element-345">
          <div className="bg-white rounded-lg shadow-sm p-6 w-full max-w-md text-center" data-id="element-346">
            <div className="flex justify-center mb-4" data-id="element-347">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={32} fill={star <= rating ? '#f9b30f' : 'none'} stroke={star <= rating ? '#f9b30f' : 'currentColor'} className="mx-1" data-id="element-348" />)}
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-349">
              Bedankt voor je feedback!
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-350">
              We waarderen je mening en gebruiken deze om onze service te
              verbeteren.
            </p>
            <button onClick={() => {
            setIsSubmitted(false);
            setRating(0);
            setComment('');
          }} className="bg-[#f9b30f] text-black py-2 px-4 rounded-lg font-medium" data-id="element-351">
              Nieuwe review plaatsen
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-352">
      <Header title="Feedback & Reviews" showBackButton data-id="element-353" />
      <div className="p-4" data-id="element-354">
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4" data-id="element-355">
          <h2 className="text-lg font-bold mb-2" data-id="element-356">Hoe was je verblijf?</h2>
          <p className="text-sm text-gray-600 mb-4" data-id="element-357">
            We horen graag wat je van je verblijf bij Camping Olympia vond!
          </p>
          <form onSubmit={handleSubmit} data-id="element-358">
            <div className="mb-4" data-id="element-359">
              <label className="block text-sm font-medium mb-2" data-id="element-360">
                Beoordeling
              </label>
              <div className="flex" data-id="element-361">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} className="mr-2" data-id="element-362">
                    <StarIcon size={32} fill={star <= rating ? '#f9b30f' : 'none'} stroke={star <= rating ? '#f9b30f' : 'currentColor'} data-id="element-363" />
                  </button>)}
              </div>
            </div>
            <div className="mb-6" data-id="element-364">
              <label className="block text-sm font-medium mb-2" data-id="element-365">
                Je ervaring
              </label>
              <textarea value={comment} onChange={e => setComment(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 text-sm" rows={4} placeholder="Vertel ons wat je goed vond en wat beter kan..." data-id="element-366" />
            </div>
            <button type="submit" disabled={rating === 0} className={`w-full py-3 rounded-lg flex items-center justify-center font-medium ${rating === 0 ? 'bg-gray-200 text-gray-500' : 'bg-[#f9b30f] text-black'}`} data-id="element-367">
              <SendIcon size={18} className="mr-2" data-id="element-368" />
              Review plaatsen
            </button>
          </form>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-369">
          <h3 className="font-medium mb-3" data-id="element-370">
            Andere gasten over Camping Olympia
          </h3>
          <div className="space-y-4" data-id="element-371">
            <ReviewCard name="Familie de Vries" rating={5} date="Juli 2023" comment="Geweldige camping met vriendelijk personeel! De kinderen hebben genoten van het zwembad en de activiteiten. We komen zeker terug!" data-id="element-372" />
            <ReviewCard name="Tim & Lisa" rating={4} date="Augustus 2023" comment="Mooie, rustige camping aan de rivier. Goede faciliteiten en leuke sfeer. De safaritent was comfortabel en schoon." data-id="element-373" />
          </div>
        </div>
      </div>
    </div>;
};
const ReviewCard = ({
  name,
  rating,
  date,
  comment
}) => {
  return <div className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0" data-id="element-374">
      <div className="flex justify-between items-center mb-2" data-id="element-375">
        <span className="font-medium" data-id="element-376">{name}</span>
        <span className="text-sm text-gray-500" data-id="element-377">{date}</span>
      </div>
      <div className="flex mb-2" data-id="element-378">
        {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={16} fill={star <= rating ? '#f9b30f' : 'none'} stroke={star <= rating ? '#f9b30f' : 'currentColor'} className="mr-1" data-id="element-379" />)}
      </div>
      <p className="text-sm text-gray-600" data-id="element-380">{comment}</p>
    </div>;
};
export default Feedback;